import "@hotwired/turbo-rails"
import "@rails/actiontext"
import Trix from "trix";
import "./controllers"
import './modules/index';
import * as bootstrap from "bootstrap"

window.bootstrap = bootstrap

if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/service-worker.js', { scope: './' })
                         .then(function(registration) {
                           console.log('[Companion]', 'Service worker registered!')
                           console.log(registration)
                         })
}


(() => {
  (document.querySelectorAll('a')).forEach(link => {
    link.hostname !== location.hostname && link.setAttribute('target', '_blank');
  })
})();


